// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoCipStatusSummaryRecordDto } from './IReportSummaryGroupDtoCipStatusSummaryRecordDto';
import {
    IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoCipStatusSummaryRecordDto';
import type { ICipStatusSummaryRecordDto } from './ICipStatusSummaryRecordDto';
import {
    ICipStatusSummaryRecordDtoFromJSON,
    ICipStatusSummaryRecordDtoFromJSONTyped,
    ICipStatusSummaryRecordDtoToJSON,
    ICipStatusSummaryRecordDtoToJSONTyped,
} from './ICipStatusSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoCipStatusSummaryRecordDto
 */
export interface IReportSummaryDtoCipStatusSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoCipStatusSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<ICipStatusSummaryRecordDto>}
     * @memberof IReportSummaryDtoCipStatusSummaryRecordDto
     */
    employer_records?: Array<ICipStatusSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoCipStatusSummaryRecordDto>}
     * @memberof IReportSummaryDtoCipStatusSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoCipStatusSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoCipStatusSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoCipStatusSummaryRecordDto(value: object): value is IReportSummaryDtoCipStatusSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoCipStatusSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoCipStatusSummaryRecordDto {
    return IReportSummaryDtoCipStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoCipStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoCipStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(ICipStatusSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCipStatusSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoCipStatusSummaryRecordDtoToJSON(json: any): IReportSummaryDtoCipStatusSummaryRecordDto {
    return IReportSummaryDtoCipStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoCipStatusSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoCipStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(ICipStatusSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCipStatusSummaryRecordDtoToJSON)),
    };
}

